import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { CognitoUserInterface } from '@aws-amplify/ui-components';
import { AuthService } from 'src/core/services/auth.service';

@Component({
  selector: 'core-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss']
})
export class AccountDetailsComponent implements OnInit, AfterViewInit {
  @Input() user: CognitoUserInterface;
  @Input() roles: string[];
  @Output() autoClose = new EventEmitter<void>()
  constructor(
    private _auth: AuthService
  ) { }

  ngAfterViewInit(): void {
    const details = <HTMLElement>document.querySelector('.details');
    if (details) details.focus();
  }

  ngOnInit(): void {

  }

  async signOut() {
    this.autoClose.emit();
    await this._auth.signOut();
  }

  onBlur(event: FocusEvent) {
    const details = <HTMLElement>event.target;
    const button = <HTMLElement>event.relatedTarget;
    if (!details.contains(button))
      this.autoClose.emit();
  }

}
